import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import React, { useState, useEffect, useRef } from 'react';
import {
  Grid, TextField, Button, MenuItem, Checkbox, FormControlLabel,
  FormGroup, Select, InputLabel, FormControl, Typography, Paper,
  Dialog, DialogTitle, DialogContent, DialogActions, Autocomplete
} from '@mui/material';
import axios from 'axios';
import { API_URL } from '../../api';
import { salvarCadastroGPD } from '../api/gpdApi';
const API_FILES = 'https://projetos.impram.com.br';
import { Box, Collapse } from '@mui/material';






const statusList = [
  'NÃO INICIADO', 'EM DESENVOLVIMENTO', 'AMOSTRAS', 'COLETA DE ESTIMATIVAS',
  'CONCLUÍDO', 'CANCELADO', 'AGUARDANDO INF. COMERCIAL', 'ORÇAMENTO NOVA PÁGINA',
  'ORÇAMENTO DE FACA'
];

const categoriasList = [
  'NOVOS DESENVOLVIMENTO', 'ORCAMENTO DE FACAS', 'AMOSTRAS', 'FILME DE FACAS',
  'DESENHO INDIVIDUAL', 'ALTERAÇÃO DE DESENHO','ORCAMENTO NP'
];

const responsaveisPD = [
  'GERSON', 'VIVIANNE', 'MARCUS', 'NARLISON',
  'MAQUINÉ', 'SILAS', 'SUELEM', 'RICARDO', 'CAMILA'
];

const tiposProjeto = [
  'Embalagem Cartão', 'Embalagem Cartão Empastado', 'Micro ONDA G',
  'Micro ONDA F', 'Micro ONDA B', 'CAIXA RÍGIDA', 'PROJETO ESPECIAL', 'CARTELA'
];

const prioridades = ['BAIXA', 'MÉDIA', 'ALTA'];

const acabamentosList = [
  'VERNIZ BRILHO', 'VERNIZ FOSCO', 'VERNIZ BLISTER', 
  'VERNIZ SOFT', 'RESERVA DE COLA','DESMOLDANTE', 'PASTA FOSCO','VERNIZ UV LOCAL', 'LAMINAÇÃO BRILHO', 'LAMINAÇÃO FOSCA', 
  'HOTSTAMPING', 'BAIXO RELEVO', 'ALTO RELEVO',
  'VERNIZ PRIME', 'BOPP SCUFF FREE' 
];



const acondicionamentos = ['CAIXA DE PAPELÃO', 'PALETE', 'BIC002', 'BIC004','GEN002','GEN003','NOK010','NOK015','ESS001','SKY001','MMM001','A DEFINIR'];

function FormularioGPD({ onSalvar, onVoltar, itemEdicao, clientes: clientesProp, carregarClientes, usuario, carregarDados }) {
  const usuarioLogado = JSON.parse(localStorage.getItem('usuario'))?.nome || 'Desconhecido';

  const [alteracoes, setAlteracoes] = useState([]);

  const [dadosOriginais, setDadosOriginais] = useState(null);
  

  const [arquivosEnviados, setArquivosEnviados] = useState([]);
  const [progressoArquivos, setProgressoArquivos] = useState({});
  const [baixandoZip, setBaixandoZip] = useState(false);

  const [pdfFile, setPdfFile] = useState(null);

const handleFileChange = (e) => {
  setPdfFile(e.target.files[0]);
};

const handleProcessarPDF = () => {
  if (pdfFile && typeof onUploadPDF === 'function') {
    onUploadPDF(pdfFile);
  } else {
    alert('Selecione um PDF primeiro.');
  }
};


  const [progressoZip, setProgressoZip] = useState(0);
  const progressoRef = useRef(0);



const [desenhoTecnico, setDesenhoTecnico] = useState(null);



const [acabamentosSelecionados, setAcabamentosSelecionados] = useState([]);

const toggleAcabamento = (valor, marcado) => {
  setAcabamentosSelecionados(prev =>
    marcado ? [...prev, valor] : prev.filter(v => v !== valor)
  );
};


const handleExcluirArquivo = async (nome) => {
  if (!window.confirm(`Deseja excluir o arquivo "${nome}"?`)) return;

  console.log('📁 Tentando excluir o arquivo:', nome);

  try {
    const res = await axios.delete(`${API_FILES}/upload/anexos/${nome}`);
    console.log('✅ Resposta do servidor:', res.data);
  } catch (err) {
    const msg = err?.response?.data?.erro || '';
    console.warn('⚠️ Erro ao excluir do servidor:', msg || err.message);

    if (!msg.includes('Erro ao deletar') && !msg.includes('ENOENT')) {
      alert('Erro ao tentar excluir o arquivo no servidor.');
      return;
    }

    console.warn('⚠️ Prosseguindo mesmo com erro no servidor.');
  }

  // Atualizar listas locais
  const novosArquivosEnviados = arquivosEnviados.filter(arquivo => {
    const nomeArquivo = typeof arquivo === 'string' ? arquivo : arquivo.nome;
    return nomeArquivo !== nome;
  });

  const novosAnexos = dados.anexos.filter(arquivo => {
    const nomeArquivo = typeof arquivo === 'string' ? arquivo : arquivo.nome;
    return nomeArquivo !== nome;
  });

  console.log('📎 Arquivos após remoção:', novosArquivosEnviados);
  console.log('📄 Anexos após remoção:', novosAnexos);

  setArquivosEnviados(novosArquivosEnviados);
  setDados(prev => ({ ...prev, anexos: novosAnexos }));

  // Criar payload limpo (remover campos que não existem no banco)
  const { uploading, uploadProgresso, ...dadosLimpos } = {
    ...dados,
    anexos: novosAnexos,
  };

  console.log('💾 Enviando PUT com payload LIMPO:', dadosLimpos);

  if (!dados?.id || isNaN(Number(dados.id))) {
  alert('Arquivo Excluído com Sucesso');
  return;
}


  try {
    await axios.put(`${API_URL}/gpd/itens/${dados.id}`, dadosLimpos, {
      headers: { 'Content-Type': 'application/json' }
    });

    alert('Arquivo removido e cadastro atualizado.');
  } catch (err) {
    console.error('❌ Erro ao atualizar no backend:', err);
    alert('Erro ao salvar a exclusão no banco.');
  }
};





  

  const [clientes, setClientes] = useState([]);
  const [abrirModalCliente, setAbrirModalCliente] = useState(false);
  const [novoCliente, setNovoCliente] = useState('');



 const [dados, setDados] = useState({

  


  componentes: [
  {
    materiaPrima: '',
    codigoCliente: '',
    cores: [],
    demanda: '',
    acabamentos: [] // ← Inclui aqui os acabamentos normais + com sufixo (F) ou (V)
  }
],


  uploading: false,
  uploadProgresso: 0,
  im: '', 
  subconjunto: '', 
  cliente: '', 
  projeto: '', 
  tipo: '', 
  demanda: '',
  status: 'NÃO INICIADO', 
  prioridade: '', 
  dataInicio: '', 
  dataEntrega: '',
  categorias: [], 
  responsavel: '', 
  observacao: '', 
  materiaPrima: '', 
  cores: '',
  acabamento: [], 
  acondicionamento: '', 
  anexos: [],
  dataModificacao: '', 
  dataEntregaModificacao: '', 
  usuarioUltimaModificacao: '',
  historicoAlteracoes: [], // <-- ESSENCIAL!
  cor_1: '',
  cor_2: '',
  cor_3: '',
  cor_4: '',
  cor_5: '',
  cor_6: '',
  classificacao: '',
  formCartaoInterno: '',
  solicitante: usuarioLogado // ✅ Novo campo com valor inicial automático

});


useEffect(() => {
  const componentesNormalizados = dados.componentes.map((comp) => ({
    descricaoItem: '',
    materiaPrima: '',
    codigoCliente: '',
    coresFrente: [],
    coresVerso: [],
    demanda: '',
    micro: '',
    acabamentos: [],
    impressao: '',
    quantidadeImpressao: '',
    mostrarAcabamentos: false,
    ...comp // sobrescreve com os dados existentes
  }));


  const precisaAtualizar = dados.componentes.some((comp, i) => {
    const normalizado = componentesNormalizados[i];
    return (
      typeof comp.descricaoItem === 'undefined' ||
      typeof comp.materiaPrima === 'undefined' ||
      typeof comp.codigoCliente === 'undefined' ||
      typeof comp.coresFrente === 'undefined' || 
      typeof comp.coresVerso === 'undefined' ||  
      typeof comp.cores === 'undefined' ||
      typeof comp.demanda === 'undefined' ||
      typeof comp.micro === 'undefined' ||
      typeof comp.acabamentos === 'undefined' ||
      typeof comp.impressao === 'undefined' ||
      typeof comp.quantidadeImpressao === 'undefined' ||
      typeof comp.mostrarAcabamentos === 'undefined'
    );
  });

  if (precisaAtualizar) {
    setDados((prev) => ({
      ...prev,
      componentes: componentesNormalizados
    }));
  }
}, []);







  

  function getDataFormatadaBR(date = new Date()) {
    const dia = String(date.getDate()).padStart(2, '0');
    const mes = String(date.getMonth() + 1).padStart(2, '0');
    const ano = date.getFullYear();
    return `${dia}/${mes}/${ano}`;
  }

  function dataBRParaISO(dataBR) {
    if (!dataBR || !dataBR.includes('/')) return '';
    const [dia, mes, ano] = dataBR.split('/');
    return `${ano}-${mes}-${dia}`;
  }

  function dataISOParaBR(dataISO) {
    if (!dataISO || !dataISO.includes('-')) return '';
    const [ano, mes, dia] = dataISO.split('-');
    return `${dia}/${mes}/${ano}`;
  }

  useEffect(() => {
    if (clientesProp && Array.isArray(clientesProp)) {
      setClientes(clientesProp);
    }
  }, [clientesProp]);
  

// Estado auxiliar para verificar se a classificação contém MICRO
const [mostrarCamposMicro, setMostrarCamposMicro] = useState(false);

useEffect(() => {
  setMostrarCamposMicro(
    typeof dados.classificacao === 'string' &&
    dados.classificacao.toUpperCase().includes('MICRO')
  );
}, [dados.classificacao]);

useEffect(() => {
  if (!itemEdicao?.id) return;
  console.log('🧩 itemEdicao ao reabrir modal:', itemEdicao);
  console.log('👉 Valor de itemEdicao.acondicionamento:', itemEdicao.acondicionamento);
  console.log('👉 Opções disponíveis no dropdown:', acondicionamentos);

  const novaDataInicio = itemEdicao.dataInicio || (itemEdicao.subconjunto ? getDataFormatadaBR() : '');
  const novaDataEntrega = itemEdicao.dataEntrega || (itemEdicao.status === 'CONCLUÍDO' ? getDataFormatadaBR() : '');

  setDadosOriginais({ ...itemEdicao });

  let historico = [];
  try {
    historico = Array.isArray(itemEdicao.historicoAlteracoes)
      ? itemEdicao.historicoAlteracoes
      : JSON.parse(itemEdicao.historicoAlteracoes || '[]');
  } catch {
    historico = [];
  }
  setAlteracoes(historico);

  // 🆕 Mapear anexos para garantir estrutura com nomeOriginal
  let anexosValidos = [];

  try {
    if (Array.isArray(itemEdicao.anexos)) {
      anexosValidos = itemEdicao.anexos.map(a =>
        typeof a === 'string'
          ? { nome: a, nomeOriginal: a, tamanhoMB: null }
          : {
              nome: a.nome || a,
              nomeOriginal: a.nomeOriginal || a.nome || a,
              tamanhoMB: a.tamanhoMB || null
            }
      );
    }
  } catch {
    anexosValidos = [];
  }

  console.log('📎 Anexos recuperados do item:', anexosValidos);
  setArquivosEnviados(anexosValidos);

  console.log('👉 Valor que vamos setar no dados.acondicionamento:', itemEdicao.acondicionamento || '');
console.log('🧪 Valor bruto de itemEdicao.componentes:', itemEdicao.componentes);


  let componentesNormalizados = [];
try {
  const parsed = typeof itemEdicao.componentes === 'string'
    ? JSON.parse(itemEdicao.componentes)
    : itemEdicao.componentes;

  componentesNormalizados = Array.isArray(parsed)
    ? parsed.map((comp) => ({
        descricaoItem: '',
        materiaPrima: '',
        codigoCliente: '',
        coresFrente: [],
        coresVerso: [],
        demanda: '',
        micro: '',
        acabamentos: [],
        impressao: '',
        quantidadeImpressao: '',
        mostrarAcabamentos: false,
        ...comp
      }))
    : [{
        descricaoItem: '',
        materiaPrima: '',
        codigoCliente: '',
        coresFrente: [],
        coresVerso: [],
        demanda: '',
        micro: '',
        acabamentos: [],
        impressao: '',
        quantidadeImpressao: '',
        mostrarAcabamentos: false
      }];
} catch {
  console.warn('⚠️ Erro ao processar componentes:', err);
  console.warn('❌ Valor problemático:', itemEdicao.componentes);

  componentesNormalizados = [{
    descricaoItem: '',
    materiaPrima: '',
    codigoCliente: '',
    coresFrente: [],
    coresVerso: [],
    demanda: '',
    micro: '',
    acabamentos: [],
    impressao: '',
    quantidadeImpressao: '',
    mostrarAcabamentos: false
  }];
}

setDados(prev => ({
  ...prev,
  id: itemEdicao.id,
  im: itemEdicao.im,
  subconjunto: itemEdicao.subconjunto,
  cliente: itemEdicao.cliente,
  projeto: itemEdicao.projeto,
  tipo: itemEdicao.tipo,
  demanda: itemEdicao.demanda,
  status: itemEdicao.status,
  prioridade: itemEdicao.prioridade,
  dataInicio: novaDataInicio,
  dataEntrega: novaDataEntrega,
  categorias: itemEdicao.categorias || [],
  responsavel: itemEdicao.responsavel,
  observacao: itemEdicao.observacao,
  materiaPrima: itemEdicao.materiaPrima || [], // corrigido
  cores: itemEdicao.cores || [],
  acabamento: itemEdicao.acabamento || [],
  acondicionamento: (itemEdicao.acondicionamento || '').trim().toUpperCase(),
  anexos: itemEdicao.anexos?.map(a => a.nome) || [],
  dataModificacao: itemEdicao.dataModificacao || '',
  dataEntregaModificacao: itemEdicao.dataEntregaModificacao || '',
  usuarioUltimaModificacao: itemEdicao.usuarioUltimaModificacao || '',
  historicoAlteracoes: itemEdicao.historicoAlteracoes || [],
  cor_1: itemEdicao.cor_1 || '',
  cor_2: itemEdicao.cor_2 || '',
  cor_3: itemEdicao.cor_3 || '',
  cor_4: itemEdicao.cor_4 || '',
  cor_5: itemEdicao.cor_5 || '',
  cor_6: itemEdicao.cor_6 || '',
  classificacao: itemEdicao.classificacao,
  solicitante: itemEdicao.solicitante || usuarioLogado,

  // ✅ CAMPOS DO DESENHO TÉCNICO
  dimensionalAberto: itemEdicao.dimensionalAberto || '',
  dimensionalFechado: itemEdicao.dimensionalFechado || '',
  gramatura: itemEdicao.gramatura || '',
  papel: itemEdicao.papel || '',
  tipoImpressao: itemEdicao.tipoImpressao || '',
  coresFrente: itemEdicao.coresFrente || '',
  coresVerso: itemEdicao.coresVerso || '',
  verniz: itemEdicao.verniz || '',
  refile: itemEdicao.refile || '',
  acabamentoFinal: itemEdicao.acabamentoFinal || '',
  dobra: itemEdicao.dobra || '',
  montagem: itemEdicao.montagem || '',
  observacoesGerais: itemEdicao.observacoesGerais || '',
  paletizacao: itemEdicao.paletizacao || '',

  // ✅ BOTÕES E CHECKS
  desenhoTecnico: itemEdicao.desenhoTecnico ?? null,
  primeiraProducao: itemEdicao.primeiraProducao ?? false,
  revisaoArte: itemEdicao.revisaoArte ?? false,
  formCartaoInterno: itemEdicao.formCartaoInterno ?? '',
  incluirFechadora: itemEdicao.incluirFechadora ?? '',

  // ✅ CAMPOS COMPLEMENTARES DO BACKEND
  facaAFaca: itemEdicao.facaAFaca || '',
  numeroImagens: itemEdicao.numeroImagens || '',
  responsavelPD: itemEdicao.responsavelPD || '',
  formEmProducao: itemEdicao.formEmProducao || '',
  formIdeal: itemEdicao.formIdeal || '',
  metrosLinearLaminas: itemEdicao.metrosLinearLaminas || '',
  materiaPrimaMicro: itemEdicao.materiaPrimaMicro || '',
  formProducaoMicro: itemEdicao.formProducaoMicro || '',
  formIdealMicro: itemEdicao.formIdealMicro || '',

  componentes: componentesNormalizados
}));





  // ✅ Aqui sincroniza os acabamentos com tickets F/V
  if (Array.isArray(itemEdicao.acabamento)) {
    setAcabamentosSelecionados(itemEdicao.acabamento);
  }

}, [itemEdicao?.id]);








// ------------------ USE EFECCT SEQUENCIA DE NUMEROS IM -----------------------//

useEffect(() => {
  const carregarIM = async () => {
    if (!itemEdicao?.id) {
      try {
        const res = await axios.get(`${API_URL}/gpd/proximo-im`);
        setDados(prev => ({ ...prev, im: res.data.im }));
      } catch (err) {
        console.error('Erro ao obter IM:', err);
      }
    }
  };
  carregarIM();
}, [itemEdicao]);


// ------------------ USE EFECCT SEQUENCIA DE NUMEROS IM -----------------------//


  

const handleEnviarParaPrimeiraProducao = async (item) => {
  try {
    const resposta = await axios.get(`${API_URL}/projetos`);
    const jaExiste = resposta.data.some(p =>
      p.grupos?.some(g => g.codigoIM?.toLowerCase() === item.im?.toLowerCase())
    );

    if (jaExiste) {
      alert("Este código IM já está cadastrado nos Novos Projetos.");
      return;
    }

    const novoProjeto = {
      cliente: item.cliente || '',
      nomeProjeto: item.projeto || '',
      codigoIM: item.im || '', // <-- ESSENCIAL!!
      status: 'Planejado',
      observacoesGerais: '',
      grupos: [
        {
          nome: '',
          codigoIM: item.im || '',
          codigoCV: '',
          processos: []
        }
      ]
    };

    await axios.post(`${API_URL}/projetos`, novoProjeto, {
      headers: {
        'Content-Type': 'application/json'
      }
    });

    alert("Enviado com sucesso!");
    if (typeof onAtualizarProjetos === 'function') {
      onAtualizarProjetos();
    }
  } catch (err) {
    console.error(err);
    alert("Erro ao enviar para Novos Projetos.");
  }
};


  
  
  


  function handleChange(e) {


      const camposExtras = [
    'dimensionalAberto',
    'dimensionalFechado',
    'facaAFaca',
    'numeroImagens',
    'paletizacao',
    'formEmProducao',
    'formIdeal',
    'metrosLinearLaminas',
    'formProducaoMicro', 'formIdealMicro',
    'formCartaoInterno',
    'cor_1',
    'cor_2',
    'cor_3',
    'cor_4',
    'cor_5',
    'cor_6',
    'cor_verso_1',
    'cor_verso_2',
    'cor_verso_3',
    'cor_verso_4',
    'cor_verso_5',
    'cor_verso_6',


  ];


    let { name, value } = e.target;
    if (name === 'subconjunto') {
      value = value.toUpperCase().replace(/[^A-Z]/g, '').slice(0, 2);
    }


  if (camposExtras.includes(name)) {
    return setDados(prev => ({
      ...prev,
      [name]: value
    }));
  }


    setDados(prev => {
      const atual = { ...prev, [name]: value };

      if (name === 'subconjunto' && value && !prev.dataInicio)
        atual.dataInicio = getDataFormatadaBR();

      if (name === 'status') {
        if (value === 'CONCLUÍDO' && !prev.dataEntrega)
          atual.dataEntrega = getDataFormatadaBR();
        if (prev.status !== 'CONCLUÍDO' && value === 'CONCLUÍDO')
          atual.dataEntregaModificacao = getDataFormatadaBR();
        if (prev.status === 'CONCLUÍDO' && value !== 'CONCLUÍDO')
          atual.dataEntregaModificacao = getDataFormatadaBR();
      }

      if ([
        'materiaPrima', 'cores', 'observacao', 'status', 'subconjunto', 'cliente',
        'projeto', 'tipo', 'demanda', 'prioridade', 'responsavel', 'acondicionamento'
      ].includes(name)) {
        atual.dataModificacao = getDataFormatadaBR();
        atual.usuarioUltimaModificacao = usuarioLogado;
      }
        

      return atual;
    });
  }

  function handleCheckboxChange(cat) {
    setDados(prev => ({
      ...prev,
      categorias: prev.categorias.includes(cat)
        ? prev.categorias.filter(c => c !== cat)
        : [...prev.categorias, cat]
    }));
  }

function handleAcabamentoChange(opcao) {
  setDados(prev => ({
    ...prev,
    acabamento: prev.acabamento.includes(opcao)
      ? prev.acabamento.filter(a => a !== opcao)
      : [...prev.acabamento, opcao]
  }));

  setAcabamentosSelecionados(prev =>
    prev.includes(opcao)
      ? prev.filter(a => a !== opcao)
      : [...prev, opcao]
  );
}


async function handleSubmit(e) {
  e.preventDefault();

  let erroValidacao = false;

  // Validação obrigatória: Se tiver desenho técnico, deve escolher SIM ou NO na Fechadora
  if (dados.desenhoTecnico) {
    if (dados.incluirFechadora !== 'SIM' && dados.incluirFechadora !== 'NO') {
      alert('Por favor, selecione se deve incluir a Fechadora (SIM ou NÃO). Este campo é obrigatório quando existe um Desenho Técnico.');
      erroValidacao = true;
    }
  }

  if (erroValidacao) return;



  


 const algumComponenteValido = dados.componentes.some(c => c.materiaPrima?.trim());
if (!algumComponenteValido) {
  alert('Preencha ao menos um campo Matéria Prima.');
  return;
}

  
    if (dados.id && !dados.responsavel) {
      alert('Preencha o campo Responsável P&D (obrigatório em modificações).');
      return;
    }
  
    let novoHistorico = [...alteracoes];

if (dadosOriginais) {
  const modificacoesDetalhadas = [];
  const dataHoje = getDataFormatadaBR();

  const camposTexto = [
    'cliente', 'projeto', 'materiaPrima', 'responsavel',
    'cores', 'status', 'prioridade', 'observacao', 'acondicionamento'
  ];

  camposTexto.forEach(campo => {
    const antigo = dadosOriginais[campo] || '';
    const novo = dados[campo] || '';
    if (antigo !== novo) {
      modificacoesDetalhadas.push(
        `${campo.toUpperCase()}: de "${antigo}" para "${novo}" - por ${usuarioLogado} em ${dataHoje}`
      );
    }
  });

  const compararListas = (label, listaAntiga = [], listaNova = []) => {
    const adicionados = listaNova.filter(item => !listaAntiga.includes(item));
    const removidos = listaAntiga.filter(item => !listaNova.includes(item));
  
    adicionados.forEach(item => {
      modificacoesDetalhadas.push(`${label.toUpperCase()}: Foi incluído ${item} - por ${usuarioLogado} em ${dataHoje}`);
    });
  
removidos.forEach(item => {
  modificacoesDetalhadas.push(`${label.toUpperCase()}: Foi removido ${item}`);
});


  };

  compararListas('ACABAMENTO', dadosOriginais.acabamento, dados.acabamento);
  compararListas('CATEGORIAS', dadosOriginais.categorias, dados.categorias);

  novoHistorico = [...(dadosOriginais.historicoAlteracoes || []), ...modificacoesDetalhadas];

} else {
  const dataHoje = getDataFormatadaBR();
  novoHistorico = [`Cadastro criado por ${usuarioLogado} em ${dataHoje}`];
}


    
function normalizarTexto(texto) {
  if (typeof texto !== 'string') return texto;
  try {
    return decodeURIComponent(encodeURIComponent(texto));
  } catch {
    return texto;
  }
}


const { uploading, uploadProgresso, ...dadosLimpos } = dados;

const dadosAtualizados = {
  ...dadosLimpos,
  componentes: dados.componentes,
  anexos: arquivosEnviados,
  acabamento: acabamentosSelecionados,
    historicoAlteracoes: novoHistorico.map(txt =>
    typeof txt === 'string' ? txt.normalize('NFC') : txt
    
  )
};


// ✅ INSIRA AQUI:
console.log('📤 Componentes enviados:', JSON.stringify(dadosAtualizados.componentes, null, 2));
console.log('📤 Payload final:', JSON.stringify(dadosAtualizados, null, 2));


// Incluindo campos extras do PDF
dadosAtualizados.dimensional_aberto = dados.dimensionalAberto || '';
dadosAtualizados.dimensional_fechado = dados.dimensionalFechado || '';
dadosAtualizados.faca_a_faca = dados.facaAFaca || '';
dadosAtualizados.numero_imagens = dados.numeroImagens || '';
dadosAtualizados.paletizacao = dados.paletizacao || '';
dadosAtualizados.form_em_producao = dados.formEmProducao || '';
dadosAtualizados.form_ideal = dados.formIdeal || '';
dadosAtualizados.metros_linear_laminas = dados.metrosLinearLaminas || '';
dadosAtualizados.form_producao_micro = dados.formProducaoMicro || '';
dadosAtualizados.form_ideal_micro = dados.formIdealMicro || '';
dadosAtualizados.materiaPrimaMicro = dados.materiaPrimaMicro || '';
dadosAtualizados.form_cartao_interno = dados.formCartaoInterno || '';
dadosAtualizados.cor_1 = dados.cor_1 || '';
dadosAtualizados.cor_2 = dados.cor_2 || '';
dadosAtualizados.cor_3 = dados.cor_3 || '';
dadosAtualizados.cor_4 = dados.cor_4 || '';
dadosAtualizados.cor_5 = dados.cor_5 || '';
dadosAtualizados.cor_6 = dados.cor_6 || '';









// 🛡️ Protege os anexos salvos anteriormente caso não tenham sido modificados manualmente
if (
  dados.id &&
  Array.isArray(dadosOriginais?.anexos) &&
  Array.isArray(dadosAtualizados.anexos) &&
  dadosAtualizados.anexos.length === 0 &&
  dadosOriginais.anexos.length > 0 &&
  dadosOriginais.anexos.every(arq => arquivosEnviados.includes(arq))
) {
  dadosAtualizados.anexos = dadosOriginais.anexos;
  console.log('🔁 Restaurando anexos originais (nenhuma exclusão detectada).');
}






   
  
  if (!dadosAtualizados.id) {
  dadosAtualizados.dataModificacao = getDataFormatadaBR();
  dadosAtualizados.usuarioUltimaModificacao = usuarioLogado;
}

if (!dadosAtualizados.dataInicio && dadosAtualizados.subconjunto)
  dadosAtualizados.dataInicio = getDataFormatadaBR();

if (dadosAtualizados.status === 'CONCLUÍDO' && !dadosAtualizados.dataEntrega)
  dadosAtualizados.dataEntrega = getDataFormatadaBR();

try {
  let resposta;

console.log('📤 Payload FINAL enviado para o backend:', JSON.stringify(dadosAtualizados, null, 2));

  if (dadosAtualizados.id) {
    console.log("🔍 Enviando dados:", dadosAtualizados);
    resposta = await axios.put(`${API_URL}/gpd/itens/${dadosAtualizados.id}`, dadosAtualizados, {
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      }
    });
  } else {
    console.log('📤 Dados antes do envio:', JSON.stringify(dadosAtualizados.componentes, null, 2));
    resposta = await axios.post(`${API_URL}/gpd/salvar`, dadosAtualizados);
  }

  if (resposta?.data?.sucesso) {
    alert('Cadastro salvo com sucesso!');
    setAlteracoes(resposta.data.item.historicoAlteracoes || []);

    if (onSalvar) {
      onSalvar(resposta.data.item); // ✅ SOMENTE AQUI CHAMA o onSalvar com dados reais
    }

    // atualiza o campo IM visualmente, se for um novo item
    if (!dados.id)
      setDados(prev => ({ ...prev, im: resposta.data.item.im }));
  
        if (dadosAtualizados.id && dadosOriginais) {
          const modificacoesDetalhadas = [];
          const dataHoje = getDataFormatadaBR();
        
          const camposTexto = [
            'cliente', 'projeto', 'materiaPrima', 'responsavel',
            'cores', 'status', 'prioridade', 'observacao', 'acondicionamento'
          ];
        
          camposTexto.forEach(campo => {
            const antigo = dadosOriginais[campo] || '';
            const novo = dadosAtualizados[campo] || '';
            if (antigo !== novo) {
              modificacoesDetalhadas.push(
                `${campo.toUpperCase()}: de "${antigo}" para "${novo}" - por ${usuarioLogado} em ${dataHoje}`
              );
            }
          });
        
          const compararListasDetalhadas = (label, listaAntiga, listaNova) => {
            const antigas = new Set(listaAntiga || []);
            const novas = new Set(listaNova || []);
          
            const adicionadas = [...novas].filter(item => !antigas.has(item));
            const removidas = [...antigas].filter(item => !novas.has(item));
          
            adicionadas.forEach(item => {
              modificacoesDetalhadas.push(`${label.toUpperCase()}: Foi incluída a opção ${item} - por ${usuarioLogado} em ${dataHoje}`);
            });
          
            removidas.forEach(item => {
              modificacoesDetalhadas.push(`${label.toUpperCase()}: Foi removida a opção ${item} - por ${usuarioLogado} em ${dataHoje}`);
            });
          };
          
          compararListasDetalhadas('ACABAMENTO', dadosOriginais.acabamento, dados.acabamento);
          compararListasDetalhadas('CATEGORIAS', dadosOriginais.categorias, dados.categorias);
          
        
          if (modificacoesDetalhadas.length > 0) {
            const novoHistorico = [
              ...(itemEdicao?.historicoAlteracoes || []),
              ...modificacoesDetalhadas
            ];
            setAlteracoes(novoHistorico);
            setDados(prev => ({ ...prev, historicoAlteracoes: novoHistorico }));
          }
        }
        
       
  } else {
    alert(resposta?.data?.mensagem || 'Erro ao salvar.');
  }
} catch (err) {
  alert('Erro ao salvar cadastro.');
  console.error(err);
}
  }
  
   console.log('🧾 Histórico carregado para exibição:', alteracoes);
  

  return (
    <Paper sx={{ p: 3, mb: 4 }}>
      <Typography variant="h6" gutterBottom>Cadastro GPD</Typography>
      <form onSubmit={handleSubmit}>
      
      
        <Grid container spacing={2}>





          <Grid item xs={4}><TextField label="Código IM" name="im" value={dados.im || ''} fullWidth disabled /></Grid>
          <Grid item xs={2}>
            
          <TextField
            label="Subconjunto"
            name="subconjunto"
            value={dados.subconjunto}
            onChange={handleChange}
            fullWidth
            disabled={!dados.id}
          />


            </Grid>

          <Grid item xs={4}>
            <Autocomplete
              freeSolo
              options={clientes}
              value={dados.cliente}
              onChange={(e, newValue) => {
                if (typeof newValue === 'string') {
                  setDados(prev => ({ ...prev, cliente: newValue }));
                }
              }}
              onInputChange={(e, newInputValue) => {
                setDados(prev => ({ ...prev, cliente: newInputValue }));
              }}
              renderInput={(params) => (
                <TextField {...params} label="Cliente" fullWidth required />
              )}
            />
            <Button
              size="small"
              variant="outlined"
              color="primary"
              onClick={() => setAbrirModalCliente(true)}
              sx={{ mt: 1 }}
            >
              Cadastrar Cliente
            </Button>
          </Grid>

          <Grid item xs={2}>
            <TextField
              label="Solicitante"
              name="solicitante"
              value={dados.solicitante}
              InputProps={{ readOnly: true }}
              fullWidth
            />
          </Grid>



          <Grid item xs={6}>
  <TextField
    label="Nome do Projeto"
    name="projeto"
    value={dados.projeto}
    onChange={handleChange}
    fullWidth
  />
</Grid>

<Grid item xs={6}>
  <FormControl fullWidth>
    <InputLabel id="classificacao-label">Classificação</InputLabel>
    <Select
      labelId="classificacao-label"
      name="classificacao"
      value={dados.classificacao}
      onChange={handleChange}
      label="Classificação"
    >
      {[
        'Caixa Cartão',
        'CARTELA',
        'MICRO ONDA B - PARDO',
        'MICRO ONDA B - BRANCO',
        'MICRO ONDA E - PARDO',
        'MICRO ONDA E - BRANCO',
        'MICRO ONDA F - PARDO',
        'MICRO ONDA F - BRANCO',
        'EMPASTADO',
        'CARTÃO + MICRO + CARTÃO',
        'CAIXA RIGIDA',
        'MICRO ONDA DUPLA',
        'PROJETO ESPECIAL'
      ].map(opcao => (
        <MenuItem key={opcao} value={opcao}>{opcao}</MenuItem>
      ))}
    </Select>
  </FormControl>
</Grid>



{/* CAMPO NÃO INICIADO*/}
<Grid item xs={6}>
  <FormControl fullWidth variant="outlined">
    <InputLabel id="status-label">Status</InputLabel>
    <Select
      labelId="status-label"
      name="status"
      value={dados.status}
      onChange={handleChange}
      label="Status"
    >
      {statusList.map(status => (
        <MenuItem key={status} value={status}>
          {status}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
</Grid>


{/* CAMPO RESPONSAVEL P&D*/}
<Grid item xs={6}>
  <FormControl fullWidth disabled={!dados.subconjunto} variant="outlined">
    <InputLabel id="responsavel-label">Responsável P&D</InputLabel>
    <Select
      labelId="responsavel-label"
      name="responsavel"
      value={dados.responsavel}
      onChange={handleChange}
      label="Responsável P&D"
    >
      {responsaveisPD.map(r => (
        <MenuItem key={r} value={r}>
          {r}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
</Grid>






<Grid item xs={6}>
  <FormControl fullWidth><InputLabel>Prioridade</InputLabel>
    <Select name="prioridade" value={dados.prioridade} onChange={handleChange}>
      {prioridades.map(p => <MenuItem key={p} value={p}>{p}</MenuItem>)}
    </Select>
  </FormControl>
</Grid>


            <Grid item xs={3}>
  <TextField
    type="date"
    label="Data Início"
    name="dataInicio"
    value={dataBRParaISO(dados.dataInicio)}
    onChange={handleChange}
    fullWidth
    InputLabelProps={{ shrink: true }}
  />
</Grid>

<Grid item xs={3}>
  <TextField
    type="date"
    label="Data Entrega"
    name="dataEntrega"
    value={dataBRParaISO(dados.dataEntrega)}
    onChange={handleChange}
    fullWidth
    InputLabelProps={{ shrink: true }}
  />
</Grid>


          <Grid item xs={3}>
  <TextField
    label="Data de Modificação"
    name="dataModificacao"
    value={dados.dataModificacao || ''}
    fullWidth
    InputLabelProps={{ shrink: true }}
    InputProps={{ readOnly: true }}
  />
</Grid>
<Grid item xs={3}>
  <TextField
    label="Modificação Entrega"
    name="dataEntregaModificacao"
    value={dados.dataEntregaModificacao || ''}
    fullWidth
    InputLabelProps={{ shrink: true }}
    InputProps={{ readOnly: true }}
  />
</Grid>
<Grid item xs={6}>
  <TextField
    label="Usuário Modificação"
    name="usuarioUltimaModificacao"
    value={dados.usuarioUltimaModificacao || ''}
    fullWidth
    InputLabelProps={{ shrink: true }}
    InputProps={{ readOnly: true }}
  />
</Grid>

          {/*GRADE CATEGORIAS*/}
          <Grid item xs={12}>
            <Typography variant="subtitle1">Categorias</Typography>
            <Grid container spacing={1}>
              {categoriasList.map((cat, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={dados.categorias.includes(cat)}
                        onChange={() => handleCheckboxChange(cat)}
                      />
                    }
                    label={cat}
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>



{/*GRADE MATERIA PRIMA, CÓDIGO DO CLIENTE, CORES, DEMANDA E ACABAMENTOS*/}




{dados.componentes?.map((item, index) => (
  <Grid item xs={12} key={index} sx={{ marginBottom: 2 }}>



    {/* Linha: Descrição do Item */}
    <Grid item xs={12} sx={{ marginBottom: 3 }}>
      <TextField
        label="Descrição do Item"
        name="descricaoItem"
        value={item.descricaoItem || ''}
        onChange={(e) => {
          const nova = [...dados.componentes];
          nova[index].descricaoItem = e.target.value;
          setDados(prev => ({ ...prev, componentes: nova }));
        }}
        fullWidth
      />
    </Grid>




    {/* Linha única: Código, Matéria Prima, Micro, Cores, Demanda, Botão */}
    <Grid item xs={12}>
      <Grid container spacing={1} alignItems="center">

        <Grid item xs={2}>
          <TextField
            label="Código do Cliente"
            name="codigoCliente"
            value={item.codigoCliente}
            onChange={(e) => {
              const nova = [...dados.componentes];
              nova[index].codigoCliente = e.target.value;
              setDados(prev => ({ ...prev, componentes: nova }));
            }}
            fullWidth
          />
        </Grid>

        <Grid item xs={3}>
          <TextField
            label="Matéria Prima"
            name="materiaPrima"
            value={item.materiaPrima}
            onChange={(e) => {
              const nova = [...dados.componentes];
              nova[index].materiaPrima = e.target.value;
              setDados(prev => ({ ...prev, componentes: nova }));
            }}
            fullWidth
          />
        </Grid>

        {dados.classificacao?.toUpperCase().includes('MICRO') && (
          <Grid item xs={3}>
            <TextField
              label="Micro"
              name="micro"
              value={item.micro || ''}
              onChange={(e) => {
                const nova = [...dados.componentes];
                nova[index].micro = e.target.value;
                setDados(prev => ({ ...prev, componentes: nova }));
              }}
              fullWidth
            />
          </Grid>
        )}

        <Grid item xs={2}>
  <TextField
    label="Demanda"
    name="demanda"
    value={item.demanda}
    onChange={(e) => {
      const nova = [...dados.componentes];
      nova[index].demanda = e.target.value;
      setDados(prev => ({ ...prev, componentes: nova }));
    }}
    fullWidth
  />
</Grid>


        <Grid item xs={1}>
          {index === 0 ? (
            <Button
              variant="outlined"
              size="small"
              onClick={() => {
                const nova = [...dados.componentes, {
                  descricaoItem: '',
                  materiaPrima: '',
                  codigoCliente: '',
                  cores: [],
                  demanda: '',
                  micro: '',
                  acabamentos: []
                }];
                setDados(prev => ({ ...prev, componentes: nova }));
              }}
              sx={{ minWidth: '30px', padding: '2px 6px' }}
            >
              + Adicionar
            </Button>
          ) : (
            <Button
              variant="outlined"
              color="error"
              size="small"
              onClick={() => {
                const nova = dados.componentes.filter((_, i) => i !== index);
                setDados(prev => ({ ...prev, componentes: nova }));
              }}
              sx={{ minWidth: '30px', padding: '2px 6px' }}
            >
              X Excluir
            </Button>
          )}
        </Grid>

{/* Cores desce para a próxima linha */}
<Grid item xs={12}>


<Grid container alignItems="center" spacing={1} sx={{ mb: 2, mt: 1 }}>
  <Grid item>
    <Typography variant="subtitle2" sx={{ fontSize: '1.25rem' }}>
  Especificar Cores
</Typography>

  </Grid>


<Grid item xs={3} sx={{ mt: 1, mb: 2, ml: 2 }}>
  <FormControl fullWidth size="small" variant="outlined">
    <InputLabel>Impressão</InputLabel>
    <Select
      name="impressao"
      value={item.impressao || ''}
      onChange={(e) => {
        const nova = [...dados.componentes];
        nova[index].impressao = e.target.value;
        setDados(prev => ({ ...prev, componentes: nova }));
      }}
      label="Impressão"
    >
      <MenuItem value="SÓ FRENTE">SÓ FRENTE</MenuItem>
      <MenuItem value="FRENTE E VERSO">FRENTE E VERSO</MenuItem>
      <MenuItem value="REVERSÃO">REVERSÃO</MenuItem>
      <MenuItem value="SEM IMPRESSÃO">SEM IMPRESSÃO</MenuItem>
    </Select>
  </FormControl>
</Grid>
{item.impressao !== 'SEM IMPRESSÃO' && (
<Grid item xs={2} sx={{ mt: 1, mb: 2, ml: 0 }}>
  <FormControl fullWidth size="small" variant="outlined">
    <InputLabel>Quantidade</InputLabel>
    <Select
      name="quantidadeImpressao"
      value={item.quantidadeImpressao || ''}
      onChange={(e) => {
        const nova = [...dados.componentes];
        nova[index].quantidadeImpressao = e.target.value;
        setDados(prev => ({ ...prev, componentes: nova }));
      }}
      label="Impressão"
    >
      {[
        '1x0', '1x1', '1x2', '1x3', '1x4', '1x5', '1x6',
        '2x0', '2x1', '2x2', '2x3', '2x4', '2x5', '2x6',
        '3x0', '3x1', '3x2', '3x3', '3x4', '3x5', '3x6',
        '4x0', '4x1', '4x2', '4x3', '4x4', '4x5', '4x6',
        '5x0', '5x1', '5x2', '5x3', '5x4', '5x5', '5x6',
        '6x0', '6x1', '6x2', '6x3', '6x4', '6x5', '6x6'
      ].map(opcao => (
        <MenuItem key={opcao} value={opcao}>{opcao}</MenuItem>
      ))}
    </Select>
  </FormControl>
</Grid>
)}


{item.impressao !== 'SEM IMPRESSÃO' && (
  <Grid item>
    <Button
      size="small"
      variant="outlined"
      sx={{ minWidth: '30px', padding: '1px 6px', fontSize: '0.7rem' }}
      onClick={() => {
  const nova = [...dados.componentes];
  nova[index].coresFrente = ['CIANO', 'MAGENTA', 'AMARELO', 'PRETO'];
  setDados(prev => ({ ...prev, componentes: nova }));
}}

    >
      CMYK
    </Button>
  </Grid>
  )}



</Grid>


{item.impressao !== 'SEM IMPRESSÃO' && (
  <Grid container spacing={1}>
    {[0,1,2,3,4,5].map((n) => (
      <Grid item xs={2} key={n}>
        <TextField
          size="small"
          label={`Cor Frente ${n+1}`}
          name={`cor_${n}`}
          value={dados.componentes?.[index]?.coresFrente?.[n] || ''}
          onChange={(e) => {
            const nova = [...dados.componentes];
            const coresFrenteArray = Array.isArray(nova[index].coresFrente) ? [...nova[index].coresFrente] : [];
            coresFrenteArray[n] = e.target.value;
            nova[index].coresFrente = coresFrenteArray;
            setDados(prev => ({ ...prev, componentes: nova }));
          }}

          fullWidth
        />
      </Grid>






    ))}
  </Grid>
  )}


{(item.impressao === 'FRENTE E VERSO' || item.impressao === 'REVERSÃO') && (
  <Grid container spacing={1} sx={{ mt: 1 }}>
    {[0,1,2,3,4,5].map((n) => (
      <Grid item xs={2} key={`verso-${n}`}>
        <TextField
          size="small"
          label={`Cor Verso ${n+1}`}
          name={`cor_verso_${n+1}`}
          value={dados.componentes?.[index]?.coresVerso?.[n] || ''}
          onChange={(e) => {
            const nova = [...dados.componentes];
            const coresVersoArray = Array.isArray(nova[index].coresVerso) ? [...nova[index].coresVerso] : [];
            coresVersoArray[n] = e.target.value;
            nova[index].coresVerso = coresVersoArray;
            setDados(prev => ({ ...prev, componentes: nova }));
          }}
          fullWidth
        />
      </Grid>
    ))}
  </Grid>
)}



{item.impressao !== 'SEM IMPRESSÃO' && (
  <Grid item xs={3} sx={{ mt: 2 }}>
    <TextField
      size="small"
      label="Marca da Tinta"
      name="marcaTinta"
      value={dados.componentes?.[index]?.marcaTinta || ''}
      onChange={(e) => {
        const nova = [...dados.componentes];
        nova[index].marcaTinta = e.target.value;
        setDados(prev => ({ ...prev, componentes: nova }));
      }}
      fullWidth
    />
  </Grid>
)}





</Grid>



      </Grid>
    </Grid>






{/* Botão para Mostrar/Ocultar Acabamentos por Item */}
<Grid item xs={12} sx={{ mt: 3, mb:2 }}>
  <Button
    size="small"
    variant="outlined"
    onClick={() => {
      const nova = [...dados.componentes];
      nova[index].mostrarAcabamentos = !nova[index].mostrarAcabamentos;
      setDados(prev => ({ ...prev, componentes: nova }));
    }}
  >
    {item.mostrarAcabamentos ? 'Ocultar Acabamentos' : 'Mostrar Acabamentos'}
  </Button>
</Grid>

{/* Lista de Acabamentos (mostra apenas se o estado mostrarAcabamentos for true) */}
{item.mostrarAcabamentos && (
  <Grid item xs={12}>
    <Grid container spacing={1}>


{acabamentosList.map((acabamento, idxAcab) => (
  <Grid item xs={12} sm={6} md={4} key={idxAcab}>
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        minHeight: '26px',
        pr: 13
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 500, flexShrink: 0, whiteSpace: 'nowrap' }}>
        {acabamento}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          gap: 0,
          justifyContent: 'flex-end',
          minWidth: '45px'
        }}
      >
        {['F', 'V'].map((lado) => {
          const valor = `${acabamento} (${lado})`;
          const estaMarcado = item.acabamentos?.includes(valor);
          return (
            <FormControlLabel
              key={lado}
              control={
                <Checkbox
                  size="small"
                  checked={estaMarcado}
                  onChange={() => {
                    const nova = [...dados.componentes];
                    const listaAtual = nova[index].acabamentos || [];
                    if (estaMarcado) {
                      nova[index].acabamentos = listaAtual.filter(a => a !== valor);
                    } else {
                      nova[index].acabamentos = [...listaAtual, valor];
                    }
                    setDados(prev => ({ ...prev, componentes: nova }));
                  }}
                />
              }
              label={lado}
              sx={{
                m: 0,
                pl: 0,
                pr: 0,
                '.MuiTypography-root': { fontSize: '0.7rem' }
              }}
              componentsProps={{ typography: { variant: 'caption' } }}
            />
          );
        })}
      </Box>
    </Box>
  </Grid>
))}



    </Grid>
  </Grid>
)}





  </Grid>
))}







{/* Acondicionamento + Botões lado a lado */}
<Grid item xs={6} sx={{ mt: 3 }}>
  
{/* ✅ LOGS DE DEBUG */}
  {console.log('👉 Valor atual do dados.acondicionamento:', dados.acondicionamento)}
  {console.log('👉 Opções disponíveis no dropdown:', acondicionamentos)}

  <FormControl fullWidth variant="outlined">

    <InputLabel id="acond-label">Acondicionamento</InputLabel>
    <Select
      labelId="acond-label"
      name="acondicionamento"
      value={acondicionamentos.includes((dados.acondicionamento || '').toUpperCase()) ? (dados.acondicionamento || '').toUpperCase() : ''}

      onChange={handleChange}
      label="Acondicionamento"
    >
      {acondicionamentos.map(a => (
        <MenuItem key={a} value={a}>
          {a}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
</Grid>






<Grid item xs={6} sx={{ mt: 3 }}>
  <Grid container spacing={1}>

    {/* Botão Anexar */}
    <Grid item xs={6}>
      <Button variant="outlined" component="label" fullWidth>
        Anexar
        <input
          hidden
          multiple
          type="file"
          onChange={async (e) => {
            const files = Array.from(e.target.files);
            for (const file of files) {
              const formData = new FormData();
              formData.append('file', file);

              try {
                setProgressoArquivos(prev => ({
                  ...prev,
                  [file.name]: { progresso: 0, status: 'enviando' }
                }));

                const res = await axios.post(`${API_FILES}/upload/anexos`, formData, {
                  headers: { 'Content-Type': 'multipart/form-data' },
                  onUploadProgress: progressEvent => {
                    const progresso = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    setProgressoArquivos(prev => ({
                      ...prev,
                      [file.name]: { progresso, status: 'enviando' }
                    }));
                  }
                });

                if (res.data.arquivo) {
                  setProgressoArquivos(prev => ({
                    ...prev,
                    [file.name]: { progresso: 100, status: 'sucesso' }
                  }));

                  setArquivosEnviados(prev => [
                    ...prev,
                    {
                      nome: res.data.arquivo,
                      nomeOriginal: res.data.nomeOriginal || file.name,
                      tamanhoMB: (file.size / (1024 * 1024)).toFixed(2)
                    }
                  ]);

                  setDados(prev => ({
                    ...prev,
                    anexos: [...prev.anexos, res.data.arquivo]
                  }));
                }

                setProgressoArquivos(prev => {
                  const copia = { ...prev };
                  delete copia[file.name];
                  return copia;
                });

              } catch (err) {
                console.error(`Erro ao enviar ${file.name}`, err);
                setProgressoArquivos(prev => ({
                  ...prev,
                  [file.name]: { progresso: 0, status: 'erro' }
                }));
                alert(`Erro ao enviar o arquivo: ${file.name}`);
              }
            }
          }}
        />
      </Button>
    </Grid>

    {/* Botão Baixar Todos */}
    {arquivosEnviados.length > 0 && (
      <Grid item xs={6}>
        <Button
          variant="outlined"
          color="success"
          fullWidth
onClick={async () => {
  try {
const nomes = arquivosEnviados.map(arq =>
  typeof arq === 'string'
    ? { nome: arq, nomeOriginal: arq }
    : { nome: arq.nome, nomeOriginal: arq.nomeOriginal || arq.nome }
);



    if (nomes.length === 0) return;

    setBaixandoZip(true);
setProgressoZip(0);
progressoRef.current = 0;

const intervalo = setInterval(() => {
  progressoRef.current += Math.random() * 10;
  if (progressoRef.current >= 90) {
    clearInterval(intervalo);
  }
  setProgressoZip(Math.min(90, Math.floor(progressoRef.current)));
}, 150);

const res = await axios.post(
  `${API_FILES}/upload/anexos/download-zip`,
  { arquivos: nomes },
  {
    responseType: 'blob',
    headers: {
      'Content-Type': 'application/json'
    }
  }
);


    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'anexos.zip');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

  } catch (err) {
    console.error('Erro ao baixar ZIP:', err);
    alert('Erro ao baixar os arquivos ZIP');
  } finally {
setProgressoZip(100);
setTimeout(() => {
  setBaixandoZip(false);
  setProgressoZip(0);
}, 1000);
  }
}}



        >
          Baixar Todos
        </Button>
      </Grid>
    )}
  </Grid>
</Grid>


{/* Barra de Progresso */}
{Object.keys(progressoArquivos).map(nome => (
    <Grid item xs={12} key={nome}>
    <Typography variant="caption">{nome} - {progressoArquivos[nome]?.progresso || 0}%</Typography>
    <div style={{ height: 10, background: '#eee', borderRadius: 5, overflow: 'hidden', marginTop: 4 }}>
      <div
        style={{
          height: '100%',
          width: `${progressoArquivos[nome]?.progresso || 0}%`,
          background: '#1976d2',
          transition: 'width 0.3s ease'
        }}
      />
    </div>
  </Grid>
))}


{baixandoZip && (
  <Grid item xs={12}>
    <Typography variant="caption">
      Baixando ZIP... {progressoZip}%
    </Typography>
    <div style={{ height: 10, background: '#eee', borderRadius: 5, overflow: 'hidden', marginTop: 4 }}>
      <div
        style={{
          height: '100%',
          width: `${progressoZip}%`,
          background: '#2e7d32',
          transition: 'width 0.4s ease-in-out'
        }}
      />
    </div>
  </Grid>
)}




{/* Lista de Arquivos Anexados */}
{arquivosEnviados.length > 0 && (
  <Grid item xs={12}>
    <Grid container spacing={1} sx={{ mt: 1 }}>
      {arquivosEnviados.map((arquivo, idx) => {
        const nome = typeof arquivo === 'string' ? arquivo : arquivo.nome || '';
        const tamanhoMB = typeof arquivo === 'object' ? arquivo.tamanhoMB : null;
        const url = typeof arquivo === 'string'
          ? `${API_FILES}/uploads/anexos/${arquivo}`
          : arquivo.url || `${API_FILES}/uploads/anexos/${nome}`;

        return (
          <Grid item xs={12} key={idx} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'none', color: '#1565c0', fontWeight: 500, flexGrow: 1 }}
            >
              📎 {arquivo.nomeOriginal || nome}
              {tamanhoMB && (
                <span style={{ marginLeft: 8, color: '#555', fontSize: '0.85em' }}>
                  ({tamanhoMB} MB)
                </span>
              )}
            </a>
            <IconButton size="small" color="error" onClick={() => handleExcluirArquivo(nome)}>
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Grid>
        );
      })}
    </Grid>
  </Grid>
)}






<Grid item xs={12}>
  <TextField
    label="Observações"
    name="observacao"
    value={dados.observacao || ''}
    onChange={handleChange}
    multiline
    minRows={4}
    fullWidth
    variant="outlined"
  />
</Grid>




{/* Visualização do Desenho Técnico (PDF ou Imagem) */}
{dados.desenhoTecnico && (
<Grid item xs={12}>
  <Typography variant="subtitle1" sx={{ mt: 2, mb: 2 }}>Desenho Técnico:</Typography>


{/* 🆕 Campos Extras do PDF: 2 linhas com 4 colunas cada */}
{usuario?.tipo?.includes('admin') && (
  <>


{/*Dimensional Aberto*/}
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={3}>
        <TextField
          label="Dimensional Aberto"
          name="dimensionalAberto"
          value={dados.dimensionalAberto || ''}
          onChange={handleChange}
          fullWidth
        />
      </Grid>



{/*Dimensional Fechado*/}
      <Grid item xs={12} sm={6} md={3}>
        <TextField
          label="Dimensional Fechado"
          name="dimensionalFechado"
          value={dados.dimensionalFechado || ''}
          onChange={handleChange}
          fullWidth
        />
      </Grid>


{/*Paletização*/}
      <Grid item xs={12} sm={6} md={3}>
        <TextField
          label="Paletização"
          name="paletizacao"
          value={dados.paletizacao || ''}
          onChange={handleChange}
          fullWidth
        />
      </Grid>


{/*Número de Imagens*/}
      <Grid item xs={12} sm={6} md={3}>
      <TextField
        label="Número de Imagens"
        name="numeroImagens"
        type="text"
        value={dados.numeroImagens || ''}
        onChange={handleChange}
        fullWidth
      />

      </Grid>



{/*Form. Produção CARTÃO*/}
      <Grid item xs={12} sm={6} md={3}>
        <TextField
          label="Form. em Produção CARTÃO"
          name="formEmProducao"
          value={dados.formEmProducao || ''}
          onChange={handleChange}
          fullWidth
        />
      </Grid>


{/*Form. Produção MICRO*/}
{mostrarCamposMicro && (
  <Grid item xs={12} sm={6} md={3}>
    <TextField
      label="Form. Produção MICRO"
      name="formProducaoMicro"
      value={dados.formProducaoMicro || ''}
      onChange={handleChange}
      fullWidth
    />
  </Grid>
)}



{/*Faca a Faca*/}
      <Grid item xs={12} sm={6} md={3}>
        <TextField
          label="Faca a Faca"
          name="facaAFaca"
          value={dados.facaAFaca || ''}
          onChange={handleChange}
          fullWidth
        />
      </Grid>



{/*Metros Linear de Lâminas*/}
      <Grid item xs={12} sm={6} md={3}>
        <TextField
          label="Metros Linear de Lâminas"
          name="metrosLinearLaminas"
          value={dados.metrosLinearLaminas || ''}
          onChange={handleChange}
          fullWidth
        />
      </Grid>




{/*Form. ideal CARTÃO*/}
      <Grid item xs={12} sm={6} md={3}>
        <TextField
          label="Form. Ideal CARTÃO"
          name="formIdeal"
          value={dados.formIdeal || ''}
          onChange={handleChange}
          fullWidth
        />
      </Grid>





{/*Form. ideal MICRO*/}
{mostrarCamposMicro && (
  <Grid item xs={12} sm={6} md={3}>
    <TextField
      label="Form. Ideal MICRO"
      name="formIdealMicro"
      value={dados.formIdealMicro || ''}
      onChange={handleChange}
      fullWidth
    />
  </Grid>
)}


{/*Form. Cartão Interno*/}
{mostrarCamposMicro && dados.classificacao === 'CARTÃO + MICRO + CARTÃO' && (
  <Grid item xs={12} sm={6} md={3}>
    <TextField
      label="Form. Cartão Interno"
      name="formCartaoInterno"
      value={dados.formCartaoInterno || ''}
      onChange={handleChange}
      fullWidth
    />
  </Grid>
)}




<Grid item xs={12} sm={6} md={3}>
  <Typography variant="subtitle2">Incluir Fechadora:</Typography>
  <FormControl component="fieldset">
    <FormGroup row>
      <FormControlLabel
        control={
          <Checkbox
            checked={dados.incluirFechadora === 'SIM'}
            onChange={() => setDados(prev => ({ ...prev, incluirFechadora: 'SIM' }))}
          />
        }
        label="SIM"
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={dados.incluirFechadora === 'NO'}
            onChange={() => setDados(prev => ({ ...prev, incluirFechadora: 'NO' }))}
          />
        }
        label="NÃO"
      />
    </FormGroup>
  </FormControl>
</Grid>






    </Grid>



  </>
)}


  <Paper variant="outlined" sx={{ width: '100%', height: 900, overflow: 'hidden' }}>





    {dados.desenhoTecnico.toLowerCase().endsWith('.pdf') ? (
<iframe
  src={`${API_FILES}/uploads/desenho_tecnico/${dados.desenhoTecnico}#toolbar=1&navpanes=0&zoom=page-fit`}
  title="Desenho Técnico PDF"
  style={{ width: '100%', height: 810, border: '1px solid #ccc' }}
/>

    ) : (
      <img
        src={`${API_FILES}/uploads/desenho_tecnico/${dados.desenhoTecnico}`}
        alt="Desenho Técnico"
        style={{ width: '100%', height: '100%', objectFit: 'contain', display: 'block' }}
      />
    )}
  </Paper>
</Grid>

)}






{alteracoes.length > 0 && (
  <Grid item xs={12}>
    <Typography variant="subtitle2" sx={{ mt: 2 }}>
      Histórico de Alterações
    </Typography>
    <Paper
      variant="outlined"
      sx={{
        maxHeight: 180,
        overflowY: 'auto',
        p: 2,
        background: '#fafafa',
        whiteSpace: 'pre-wrap',
        fontFamily: 'monospace',
        fontSize: '14px',
      }}
    >
{Array.isArray(alteracoes) && alteracoes.map((registro, idx) => (
  <div key={idx}>
    {typeof registro === 'string'
      ? registro
      : JSON.stringify(registro, null, 2)}
    {/* fallback útil se vier como objeto */}
  </div>
))}


    </Paper>
  </Grid>
)}



<Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
  {usuario?.tipo?.includes('admin') && (
    <Button variant="outlined" component="label">
      Desenho Técnico
      <input
        hidden
        type="file"
        accept=".pdf,image/*"
onChange={async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const formData = new FormData();
  formData.append('file', file);

  try {
    const res = await axios.post(`${API_FILES}/upload/desenho_tecnico`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });

    if (res.data.arquivo) {
      const nome = res.data.arquivo;
      setDados(prev => ({ ...prev, desenhoTecnico: nome }));

      // 🆕 Faz chamada ao backend para extração automática de campos do PDF
try {
  const formData = new FormData();
  formData.append('file', file);

  const extraRes = await axios.post(`${API_URL}/gpd/extrair-campos-pdf`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });

  console.log('✅ Campos extraídos do PDF:', extraRes.data);



  const camposExtraidos = extraRes?.data || {};






setDados(prev => {
  const novoEstado = { ...prev };

  // Atualizar campos simples (não relacionados a componentes)
  const camposUnitarios = [
    'dimensionalAberto', 'dimensionalFechado', 'facaAFaca', 'numeroImagens',
    'paletizacao', 'formEmProducao', 'formIdeal', 'metrosLinearLaminas',
    'formProducaoMicro', 'formIdealMicro', 'formCartaoInterno', 'acondicionamento'
  ];

  camposUnitarios.forEach(campo => {
    if (camposExtraidos[campo]) {
      novoEstado[campo] = camposExtraidos[campo];
    }
  });

  // ✅ Atualizar componentes (materiaPrima e micro), sempre na ordem sequencial: MATÉRIA PRIMA → MICRO → MATÉRIA PRIMA → MICRO...
  if (Array.isArray(camposExtraidos.materiasPrima) && camposExtraidos.materiasPrima.length > 0) {
    const materias = camposExtraidos.materiasPrima;
    const componentes = [...prev.componentes];
    const totalCamposExistentes = componentes.length * 2;  // 2 campos por grupo

    // Se faltar campos (2 por grupo), cria novos grupos
    while ((componentes.length * 2) < materias.length) {
      componentes.push({
        materiaPrima: '',
        micro: '',
        codigoCliente: '',
        cores: [],
        demanda: '',
        acabamentos: [],
        impressao: '',
        quantidadeImpressao: ''
      });
    }

    let grupoIndex = 0;
    let preenchendoCampoMicro = false;

    materias.forEach(materia => {
      const campoAlvo = preenchendoCampoMicro ? 'micro' : 'materiaPrima';

      if (grupoIndex >= componentes.length) return; // Segurança: evitar index out of range

      componentes[grupoIndex][campoAlvo] = materia;

      // Alterna entre materiaPrima e micro
      if (preenchendoCampoMicro) {
        grupoIndex++; // Após micro, pula para próximo grupo
      }

      preenchendoCampoMicro = !preenchendoCampoMicro;
    });

    novoEstado.componentes = componentes;
  }

  return novoEstado;
});








} catch (erro) {
  console.error('❌ Erro ao processar PDF:', erro);
  alert('Falha ao extrair dados do PDF.');
}






      setDesenhoTecnico({
        file,
        url: `https://projetos.impram.com.br/uploads/desenho_tecnico/${nome}`
      });
      alert('Desenho técnico enviado com sucesso!');
    }
  } catch (err) {
    console.error('Erro ao enviar desenho técnico:', err);
    alert('Erro ao enviar desenho técnico.');
  }
}}

      />
    </Button>
  )}

  <Button
    variant="outlined"
    color="secondary"
    onClick={() => {
      if (typeof onVoltar === 'function') onVoltar();
    }}
  >
    Fechar
  </Button>

  <Button type="submit" variant="contained" color="primary">
    Salvar Cadastro
  </Button>
</Grid>





{/*BOTÃO PRIMEIRA PRODUÇÃO*/}
{usuario?.tipo?.includes('admin') && (
  <Button
    variant="contained"
    color="secondary"
    title="Enviar para Primeira Produção"
    onClick={() => handleEnviarParaPrimeiraProducao(itemEdicao)}
    sx={{ mt: 2 }}
  >
    Primeira Produção
  </Button>
)}

{usuario?.tipo?.includes('admin') && (
  <Button
    variant="contained"
    color="primary"
    title="Enviar para Pré-Orçamento"
onClick={async () => {
  try {
    // Pega o estado mais recente direto antes de montar o payload
    const estadoAtual = { ...dados };
    const codigoIMPram = `${estadoAtual.im}${estadoAtual.subconjunto || ''}`;

    const dataAbertura = estadoAtual.dataInicio
      ? dataBRParaISO(estadoAtual.dataInicio)
      : new Date().toISOString().split('T')[0];

    const payload = {
      componentes: dados.componentes || [],
      cliente: estadoAtual.cliente,
      descricao: estadoAtual.classificacao,
      dataInicio: dataAbertura,
      data_abertura: dataAbertura,
      responsavel: estadoAtual.responsavel,
      classificacao: estadoAtual.classificacao,
      dimensional_fechado: estadoAtual.dimensionalFechado || 'NÃO INFORMADO',
      dimensional_aberto: estadoAtual.dimensionalAberto || 'NÃO INFORMADO',
      itensProduto: estadoAtual.componentes.map(c => ({
        codigo: c.codigoCliente || 'NÃO INFORMADO',
        descricao: c.descricaoItem || 'NÃO INFORMADO',
        demanda: c.demanda || 'NÃO INFORMADO',
        coresFrente: c.coresFrente || [],
        coresVerso: c.coresVerso || []
      })),
      materiasPrimas: estadoAtual.componentes
        .map(c => c.materiaPrima?.trim())
        .filter(mp => mp),
      codigoIM: codigoIMPram
    };

    console.log('✅ Payload FINAL para pré-orçamento:', payload);

    let resposta;

   try {
  resposta = await axios.post(`${API_URL}/preorcamento/salvar`, payload);
  console.log('✅ Resposta do backend:', resposta.data);

  if (resposta.data.criado) {
    alert('✅ Item enviado para o Pré-Orçamento com sucesso!');
  } else if (resposta.data.atualizado) {
    alert('🔁 Item do Pré-Orçamento atualizado com sucesso!');
  } else {
    alert('ℹ️ Operação realizada no Pré-Orçamento.');
  }
} catch (error) {
  console.error('❌ Erro ao salvar ou atualizar item:', error);
  alert('Erro ao enviar para o Pré-Orçamento.');
}


  } catch (error) {
    console.error('❌ Erro geral ao processar o envio:', error);
    alert('Erro inesperado ao enviar para o Pré-Orçamento.');
  }
}}
sx={{ mt: 2, ml: 2 }}
>
  Enviar para Pré-Orçamento
</Button>
)}








        </Grid>
      </form>




 {/* Modal de Clientes */}
 <Dialog open={abrirModalCliente} onClose={() => setAbrirModalCliente(false)}>
  <DialogTitle>Clientes Cadastrados</DialogTitle>
  <DialogContent dividers>
    {clientes.length === 0 && (
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Nenhum cliente cadastrado.
      </Typography>
    )}
    {clientes.map((cliente, idx) => (
      <Grid container key={idx} alignItems="center" spacing={1} sx={{ mb: 1 }}>
        <Grid item xs>
          <Typography>{cliente}</Typography>
        </Grid>
        <Grid item>
          
        {usuario?.tipo?.includes('admin') && (
          <Button
            size="small"
            color="error"
            variant="outlined"
            onClick={async () => {
              if (!window.confirm(`Deseja excluir o cliente "${cliente}"?`)) return;
              try {
                await axios.delete(`${API_URL}/clientes`, {
                  data: { nome: cliente }
                });
                if (carregarClientes) await carregarClientes(); // Atualiza globalmente                
              } catch {
                alert('Erro ao excluir cliente.');
              }
            }}
          >
            Excluir
          </Button>
          )}

          
        </Grid>
      </Grid>
    ))}

    <Typography variant="subtitle2" sx={{ mt: 2 }}>
      Adicionar Novo Cliente
    </Typography>
    <TextField
      autoFocus
      margin="dense"
      label="Nome do Cliente"
      type="text"
      fullWidth
      value={novoCliente}
      onChange={e => setNovoCliente(e.target.value)}
      sx={{ mt: 1 }}
    />
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setAbrirModalCliente(false)}>Fechar</Button>
    <Button
      onClick={async () => {
        try {
          await axios.post(`${API_URL}/clientes`, { nome: novoCliente.trim() });
          setNovoCliente('');
          if (carregarClientes) await carregarClientes(); // <-- recarrega clientes no App.js
          setAbrirModalCliente(false);          
        } catch {
          alert("Erro ao cadastrar cliente.");
        }
      }}
      variant="contained"
      color="primary"
    >
      Salvar Cliente
    </Button>
  </DialogActions>
</Dialog>

    </Paper>
  );
}

export default FormularioGPD;